var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilderSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 39C5 20.222 20.222 5 39 5s34 15.222 34 34-15.222 34-34 34S5 57.778 5 39zM39 8C21.88 8 8 21.88 8 39c0 17.12 13.88 31 31 31 17.12 0 31-13.88 31-31C70 21.88 56.12 8 39 8zm13.92 20.066a1.5 1.5 0 0 1 .264 2.105L40.161 46.914a4.75 4.75 0 0 1-6.927.615l-8.237-7.414a1.5 1.5 0 1 1 2.006-2.23l8.238 7.414a1.75 1.75 0 0 0 2.552-.226l13.023-16.744a1.5 1.5 0 0 1 2.105-.263z",
    fill: "url(#u9mrfw9wda)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "u9mrfw9wda",
    x1: 5,
    y1: 5,
    x2: 75.945,
    y2: 8.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f44a64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4541eb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilderSuccessIcon);
export default __webpack_public_path__ + "static/media/builder-success-icon.0ab199c3d566ad34f72584257150ce73.svg";
export { ForwardRef as ReactComponent };